import { render } from "./Conversationworkflow.vue?vue&type=template&id=4185c9c1"
import script from "./Conversationworkflow.vue?vue&type=script&lang=js"
export * from "./Conversationworkflow.vue?vue&type=script&lang=js"

import "./Conversationworkflow.vue?vue&type=style&index=0&id=4185c9c1&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__